import getObjectKey from 'lib/object/getObjectKey'

interface PropertyCalendarPricesKeyParams {
  propertyId: string | undefined
  duration: number | undefined
  occupancies: Array<App.Occupants> | undefined
  regionCode: string | undefined
  currency: string | undefined
}

function buildPropertyCalendarPricesKey({
  propertyId,
  duration,
  occupancies,
  regionCode,
  currency,
}: PropertyCalendarPricesKeyParams): string {
  if (!(propertyId && duration && occupancies?.length && regionCode && currency)) {
    return ''
  }
  return getObjectKey({
    propertyId,
    duration,
    rooms: occupancies,
    regionCode,
    currency,
  })
}

export default buildPropertyCalendarPricesKey
